/*
 * Purpose: Desktop primary navigation — P0 AppShell
 * Last modified: 2026-06-28 | Agent
 * Completeness: 94
 */
import { Link, useLocation } from 'react-router-dom';
import { PRIMARY_NAV, matchPrimaryNav } from '@/lib/primaryNav';
import { cn } from '@/lib/utils';

export function PrimaryNav() {
  const { pathname } = useLocation();
  const active = matchPrimaryNav(pathname);

  return (
    <nav className="hidden md:flex items-center gap-0.5" aria-label="Primary">
      {PRIMARY_NAV.map((item) => {
        const isActive = active === item.id;
        return (
          <Link
            key={item.id}
            to={item.href}
            title={item.description}
            className={cn(
              'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
              isActive
                ? 'bg-[hsl(var(--ab-green-core)/0.12)] text-[hsl(var(--ab-green-deep))] dark:text-[hsl(var(--ab-green-glow))]'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted/60'
            )}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}

export default PrimaryNav;
